import { Routes, Route, Navigate, BrowserRouter } from 'react-router-dom'
import { Suspense } from 'react'
import { Login } from '@/screens/Login'
import { StoreSetting } from '@/screens/StoreSetting'
import { Dashboard } from '@/screens/Dashboard'
import { Waiting } from '@/screens/Waiting'
import { ReviewsCenter } from '@/screens/ReviewsCenter'
import { Details } from '@/screens/Details'
import ProtectedRoute from '@/components/ProtectedRoute'

// 頁面組件 (將在後續步驟中逐一整合)
const CommentFood = () => <div className="p-8">餐點口味分析頁面 (待整合)</div>
const ChatAi = () => <div className="p-8">AI 聊天頁面 (待整合)</div>
const ChatAiCreate = () => <div className="p-8">AI 聊天建立頁面 (待整合)</div>
const Setting = () => <div className="p-8">設定頁面 (待整合)</div>
const Recent = () => <div className="p-8">最近頁面 (待整合)</div>

function App() {
    return (
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <Suspense fallback={<div className="flex items-center justify-center min-h-screen">載入中...</div>}>
                <Routes>
                    {/* 登入頁面 */}
                    <Route path="/login" element={<Login />} />

                    {/* 店家設定頁面 */}
                    <Route path="/store-setting" element={<StoreSetting />} />

                    {/* 等待頁面 - 等待後端處理資料 */}
                    <Route path="/waiting" element={<Waiting />} />

                    {/* 預設路由重定向到登入頁面 */}
                    {/* TODO: 測試完成後改回 /login */}
                    <Route path="/" element={<Navigate to="/dashboard" replace />} />

                    {/* 主要頁面路由 - 需要登入保護 */}
                    {/* TODO: 測試完成後恢復 ProtectedRoute */}
                    {/* <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} /> */}
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/reviewcenter" element={<ProtectedRoute><ReviewsCenter /></ProtectedRoute>} />
                    <Route path="/comment-food" element={<ProtectedRoute><div className="min-h-screen bg-gray-50"><CommentFood /></div></ProtectedRoute>} />
                    <Route path="/details" element={<ProtectedRoute><Details /></ProtectedRoute>} />
                    <Route path="/chat-ai" element={<ProtectedRoute><div className="min-h-screen bg-gray-50"><ChatAi /></div></ProtectedRoute>} />
                    <Route path="/chat-ai-create" element={<ProtectedRoute><div className="min-h-screen bg-gray-50"><ChatAiCreate /></div></ProtectedRoute>} />
                    <Route path="/setting" element={<ProtectedRoute><div className="min-h-screen bg-gray-50"><Setting /></div></ProtectedRoute>} />
                    <Route path="/recent" element={<ProtectedRoute><div className="min-h-screen bg-gray-50"><Recent /></div></ProtectedRoute>} />

                    {/* 404 頁面 */}
                    <Route path="*" element={<div className="min-h-screen bg-gray-50 p-8 text-center">頁面不存在</div>} />
                </Routes>
            </Suspense>
        </BrowserRouter>
    )
}

export default App
